const WooCommerce = {
  init () {

    if ( $('.woocommerce').length ) {

      // WC gallery
      // if ( $('.woocommerce-product-gallery__wrapper').length ) {
      //   $('.woocommerce-product-gallery__wrapper').slick({
      //     slidesToShow: 1,
      //     slidesToScroll: 1,
      //     autoplay: true,
      //     autoplaySpeed: 2000,
      //     infinite: true,
      //     dots: false,
      //     arrows: false,
      //     fade: true,
      //     cssEase: 'linear'
      //   });
      // }

      // if ( $('.wc-tabs').length ) {
      //   let element = document.querySelector('.wc-tabs');
      //
      //   let options = {
      //     'data-allow-all-closed': true
      //   }
      //
      //   var elem = new Foundation.ResponsiveAccordionTabs(element, options);
      // }

      // Fix for WC tabs
      if ( $('.wc-tabs').length ) {

        $('.woocommerce-tabs > .x-nav > .x-nav-tabs-item > a').on('click', function() {
          var index = $(this).data( 'cs-tab-toggle' );

          setTimeout( function() {
            $( '.woocommerce-tabs > .x-tab-content > div[data-cs-tab-index="' + index + '"] .x-nav > .x-nav-tabs-item:first-child a' ).trigger('click');
          }, 200 );
        } );

        $('.woocommerce-tabs > .x-nav > .x-nav-tabs-item:first-child > a').trigger('click');
      }

    }
  }
};

export default WooCommerce;
